import { AutogenModelDetentionHistPay, AutogenRowDetentionHistPay } from "./autogen/AutogenModelDetentionHistPay";

export class ModelDetentionHistPay extends AutogenModelDetentionHistPay<RowDetentionHistPay> {
	constructor() {
		super(RowDetentionHistPay);
	}
}

export class RowDetentionHistPay extends AutogenRowDetentionHistPay {
}